// extracted by mini-css-extract-plugin
module.exports = {"stickyWrapper":"ReviewsBase_stickyWrapper__ePy3T","sort":"ReviewsBase_sort__U2Zr5"};